import React from "react";
import { FaWhatsapp, FaPhoneAlt, FaTools, FaRedo, FaShieldAlt } from "react-icons/fa";

const MaintenanceModal = ({
  isOpen,
  onClose,
  onRetry,
  hotelPhone = "+91 9673150591",
  bookingDetails = null,
}) => {
  if (!isOpen) return null;

  const cleanPhone = hotelPhone.replace(/[^0-9]/g, "");

  // Construct helpful pre-filled WhatsApp message
  let whatsappText = "Hi Ganesh Holiday Homes Front Desk, I was trying to book online";
  if (bookingDetails) {
    const { name, checkinDate, checkoutDate, roomType, people, roomCount } = bookingDetails;
    if (name) whatsappText += ` for ${name}`;
    if (roomType) whatsappText += ` (${roomType}, ${roomCount || 1} Room)`;
    if (checkinDate && checkoutDate) {
      whatsappText += ` from ${checkinDate} to ${checkoutDate}`;
    }
    if (people) whatsappText += ` for ${people} guest(s)`;
    whatsappText += ". Since the online portal is undergoing maintenance, please assist me to confirm directly.";
  } else {
    whatsappText += " and would like to check room availability and confirm my stay directly.";
  }

  const encodedWhatsApp = encodeURIComponent(whatsappText);

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{
        backgroundColor: "rgba(7, 16, 30, 0.8)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        zIndex: 10500,
      }}
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "520px" }}>
        <div
          className="modal-content border-0 shadow-lg rounded-4 overflow-hidden"
          style={{
            background: "#ffffff",
            boxShadow: "0 25px 60px rgba(0, 0, 0, 0.35)",
          }}
        >
          {/* Header Banner */}
          <div
            className="p-4 text-center text-white position-relative"
            style={{
              background: "linear-gradient(135deg, #07101e 0%, #0b192c 50%, #1e3e62 100%)",
            }}
          >
            <button
              type="button"
              className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
              onClick={onClose}
              aria-label="Close"
            />

            <div
              className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3 shadow"
              style={{
                width: "64px",
                height: "64px",
                background: "rgba(255, 71, 87, 0.15)",
                border: "2px solid rgba(255, 71, 87, 0.4)",
                color: "#ff4757",
                fontSize: "26px",
              }}
            >
              <FaTools />
            </div>

            <div className="d-inline-flex align-items-center gap-1 bg-warning bg-opacity-25 text-warning px-3 py-1 rounded-pill small fw-semibold mb-2 border border-warning border-opacity-50">
              <FaShieldAlt /> System Maintenance in Progress
            </div>

            <h4 className="fw-bold mb-1 font-heading text-white">
              We Are Temporarily Updating Our Engine
            </h4>
            <p className="text-white-50 small mb-0">
              Our automated booking & payment service is undergoing routine server upgrades.
            </p>
          </div>

          {/* Modal Body */}
          <div className="p-4">
            <div className="p-3 bg-light rounded-3 border mb-4 text-secondary small">
              <p className="mb-2 text-dark fw-semibold">
                🛎️ <strong>Don't worry, your reservation is priority!</strong>
              </p>
              <p className="mb-0" style={{ lineHeight: "1.6" }}>
                Our front desk team is actively available 24/7. Connect with our manager directly via <strong>WhatsApp</strong> or <strong>Phone Call</strong> to secure your stay with zero delays.
              </p>
            </div>

            {/* Direct Connect Actions */}
            <div className="d-grid gap-2 mb-3">
              <a
                href={`https://wa.me/${cleanPhone}?text=${encodedWhatsApp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success py-3 rounded-3 fw-bold d-flex align-items-center justify-content-center gap-2 shadow-sm"
              >
                <FaWhatsapp className="fs-5" /> Book Instantly via WhatsApp
              </a>

              <a
                href={`tel:${cleanPhone}`}
                className="btn btn-outline-dark py-2 rounded-3 fw-semibold d-flex align-items-center justify-content-center gap-2"
              >
                <FaPhoneAlt /> Call Front Desk ({hotelPhone})
              </a>
            </div>

            {/* Bottom Actions */}
            <div className="d-flex justify-content-between align-items-center pt-3 border-top mt-3">
              {onRetry && (
                <button
                  type="button"
                  onClick={onRetry}
                  className="btn btn-link text-decoration-none text-secondary small p-0 d-inline-flex align-items-center gap-1"
                >
                  <FaRedo /> Try Reconnecting
                </button>
              )}
              <button
                type="button"
                onClick={onClose}
                className="btn btn-sm btn-light border px-3 rounded-pill ms-auto"
              >
                Dismiss
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceModal;
